import { Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getMeta } from 'constants/meta';
import Form from 'components/Form';
import Button from 'components/Button';
import Head from 'components/Head';
import { InputHasError } from 'components/Input/InputVariants';
import { apiPasswordRecovery } from 'constants/api';

import LoginHeader from './LoginHeader';

const RECOVERY_PROPS = {
  title: 'Reset Password',
  text: "We'll send you a link to reset your password.",
};

const RecoveryForm = props => {
  const handleRecoveryResponse = () => {
    const { history } = props;
    history.push({
      pathname: '/login/success',
      state: {
        from: history.location.pathname,
      },
    });
  };
  const { location } = props;
  const { title, description } = getMeta(location.pathname);
  return (
    <Fragment>
      <Head title={title} description={description} />
      <LoginHeader {...RECOVERY_PROPS} />
      <Form
        className="login__form _mb-37"
        request={apiPasswordRecovery.reset}
        initialValues={{ email: '' }}
        onResponse={handleRecoveryResponse}
        skipSubmitErrors
      >
        {({ errors, submitting, onChange }) => (
          <Fragment>
            <div className="login__form-row _mb-20">
              <InputHasError
                className="input login__input"
                name="email"
                placeholder="Your email or domain"
                error={errors.email}
                onChange={onChange}
              />
            </div>
            <div className="login__form-row">
              <Button className="btn_brand login__btn" submitting={submitting}>
                Reset Password
              </Button>
            </div>
          </Fragment>
        )}
      </Form>
      <div className="text login__subtitle _mb-10">Remember your password?</div>
      <div className="login__link-wrap _mb-60">
        <Link to="/login" className="link login__link">
          Back to Login
        </Link>
      </div>
    </Fragment>
  );
};

export default withRouter(RecoveryForm);
